<template>
  <div>
    <title-edit header="Service area" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service area name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service area name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Floor* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionFloor" :model="form.floor_id" @update="updateFloor" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Access type* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option
          :items="optionAccessType"
          :model="form.access_type_id"
          @update="updateAccessType"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slide image* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeImage(index)">
              <v-img
                :src="image.full_image_path"
                title="click for remove image"
                width="250px"
                height="200px"
              />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload
          id="image"
          menu="service_area"
          @update="updateSlideImage"
          width="150px"
          height="150px"
        />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteServiceArea" @save-info="saveServiceArea" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import SelectOption from "../../../components/Input/selectOption";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import LineHr from "../../../components/Icon/line-hr";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
import {permissionServiceArea, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "ServiceAreaEdit",
  components: {
    CommandButton,
    SwitchSelect,
    LineHr,
    SaveButton,
    PreviewButton,
    DeleteButton,
    TitleEdit,
    InputImageUpload,
    SelectOption,
    InputEditor,
    InputTextField
  },
  computed: {
    permissionServiceArea,
    ...mapState({
      form: state => {
        return state.ServicesArea.form;
      }
    })
  },
  data() {
    return {
      permission : null,
      optionBranch: [],
      optionFloor: [],
      optionAccessType: [
        { text: "Select", value: "" },
        { text: "Publish", value: 1 },
        { text: "Private", value: 2 }
      ],
      save_id: null
    };
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.getFloorData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    getFloorData() {
      this.$store.dispatch("Floor/getFloorAll").then(res => {
        this.optionFloor = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id === this.form.branch_id).map(type => ({
            value: type.floor_id,
            text: type.floor_number + '-' + type.floor_name
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        Swal('','Please select Branch !','error');
        return false;
      } else if (!this.form.name_th) {
        Swal('','Please insert Service area name TH !','error');
        return false;
      } else if (!this.form.name_en) {
        Swal('','Please insert Service area name EN !','error');
        return false;
      // } else if (!this.form.description_th) {
      //   Swal('','Please insert Description TH !','error');
      //   return false;
      // } else if (!this.form.description_en) {
      //   Swal('','Please insert Description EN !','error');
      //   return false;
      } else if (!this.form.floor_id) {
        Swal('','Please select floor !','error');
        return false;
      } else if (!this.form.access_type_id) {
        Swal('','Please select Access type !','error');
        return false;
      }else {
        return true;
      }
    },
    goToServiceAreaTable() {
      this.$router.push("/services/service-area");
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("ServicesArea/saveServiceArea", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToServiceAreaTable();
                  }
                })
                .catch(() => {
                  Swal('','Cannot save service area data!','error');
                });
      }
    },
    saveServiceArea() {
      if (this.validateSave()) {
        this.$store
          .dispatch("ServicesArea/saveServiceArea", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Cannot save service area data!','error');
          });
      }
    },
    deleteServiceArea() {
      this.$store
        .dispatch("ServicesArea/deleteServiceArea", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code === 200) {
            this.goToServiceAreaTable();
          }
        })
        .catch(() => {
          Swal('','Delete service area failed!','error');
        });
    },
    removeImage(index) {
      this.$store.dispatch("ServicesArea/removeImage", index);
    },
    updateSlideImage(val) {
      let data = {
        slide_image: val.imagePath,
        full_image_path: val.fullImagePath
      };
      this.$store.dispatch("ServicesArea/addImage", data);
    },
    updateBranch(val) {
      this.form.branch_id = val;
      this.getFloorData();
    },
    updateFloor(val) {
      this.form.floor_id = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateImages(val) {
      this.form.images_show = val.fullImagePath;
      this.form.images = val.imagePath;
    },
    updateAccessType(val) {
      this.form.access_type_id = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
.label {
  text-align: right;
}
</style>
